import React from "react";
import { Card, Button, Badge } from "react-bootstrap";
import { FaUsers, FaCalendarAlt, FaDoorOpen } from "react-icons/fa";
import { Building2, Wrench, ArrowRight } from "lucide-react";
import localization from "../../services/localization";
import moment from "moment";

export function ClassroomCard({ classroom, onEnter }) {
  const isUtility = classroom?.type === "utilities";

  const studentCount = classroom.members?.length || 0;

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("DD/MM/YYYY");
  };

  /* ------------------------------
      Utilities Card
  ------------------------------ */

  if (isUtility) {
    return (
      <Card
        onClick={() => onEnter(classroom)}
        className="common-card hover:shadow-2xl shadow-md transition-shadow cursor-pointer backdrop-blur border mb-4 p-2 rounded-2xl w-full  min-w-[450px]"
      >
        <Card.Body className="flex items-center justify-between">
          <div className="flex items-start gap-4">
            <div className="main-icon flex h-12 w-12 items-center justify-center rounded-xl shadow-md">
              <Wrench size={24} />
            </div>

            <div className="flex flex-col items-start text-left">
              <h5 className="font-bold text-lg m-0 text-left">{classroom.name || "Utilities"}</h5>

              <span className="text-sm text-left" style={{ color: "var(--module-card-description-color)" }}>
                {localization.utilities_description || "Access system modules"}
              </span>
            </div>
          </div>

          <ArrowRight size={22} className="opacity-70" />
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="common-card hover:shadow-2xl shadow-md transition-shadow cursor-pointer backdrop-blur border mb-4 p-3 rounded-2xl w-full flex flex-col  min-w-[450px]">
      <Card.Body className="flex flex-col gap-2 flex-1">
        {/* Title */}
        <div className="flex items-center gap-4">
          <div className="main-icon flex h-12 w-12 items-center justify-center rounded-xl shadow-md shrink-0">
            <Building2 size={26} />
          </div>

          <div className="flex items-center justify-between flex-1">
            <span className="text-lg font-bold break-words">{classroom.name}</span>
          </div>
        </div>
        {classroom.description && (
          <div
            className="page-subtitle text-sm mt-2 mb-4 text-left break-words"
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 2,
              cursor: "pointer",
            }}
          >
            {classroom.description}
          </div>
        )}

        {/* Members + Dates */}
        <div
          className="flex flex-wrap items-center gap-3 text-sm"
          style={{ color: "var(--module-card-description-color)" }}
        >
          <Badge className="badge-color flex items-center gap-1">
            <FaUsers className="h-4 w-4 sub-icon" />
            {studentCount} {localization.members || "Members"}
          </Badge>

          <div className="flex items-center gap-1">
            <FaCalendarAlt className="h-4 w-4 sub-icon" />
            {formatDate(classroom.start_date)} - {formatDate(classroom.end_date)}
          </div>
        </div>

        {/* Button */}
        <div className="mt-auto flex justify-end">
          <Button
            variant="primary"
            size="sm"
            className="action-btn enter flex items-center gap-2"
            onClick={() => onEnter(classroom)}
          >
            <span className="p-0.5">{localization.enter || "Enter"}</span>

            <ArrowRight size={16} />
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
